export default __webpack_public_path__ + "static/media/tokyo.c8828eb3.jpg";